/**
 * Mapeo de categorías de tareas con sus tipos asociados
 */
export const TASK_TYPE_MAPPING = {
  assurance: {
    title: 'Rappels d\'échéance assurances',
    types: [
      'assurance_proprietaire',
      'assurance_locataire',
      'assurance_proprietaire_verification_initiale',
      'assurance_locataire_verification_initiale'
    ],
    hasForm: true
  },
  diagnostic: {
    title: 'Rappels d\'échéance diag',
    types: [
      'diagnostic_dpe',
      'diagnostic_amiante',
      'diagnostic_electricite',
      'diagnostic_gaz',
      'diagnostic_plomb'
    ],
    hasForm: true
  },
  entretien: {
    title: 'Entretien',
    types: ['entretien'],
    hasForm: true // Modifié de false à true
  },
  facturation: {
    title: 'Statut de la facturation',
    types: ['facturation'], // pour les entretiens et les interventions
    hasForm: false
  }
}

/**
 * Définition des champs de formulaire par type de tâche
 * Utilisé pour générer dynamiquement les formulaires
 */
export const RENEW_TASK_FORM_FIELDS = {
  // Champs pour les assurances propriétaire
  assurance_proprietaire: [
    {name: "assurance_proprietaire", label: "Assurance propriétaire", type: "toggle", className: "w-1/3"},
    {name: "assurance_proprietaire_date_dernier_releve",
      label: "Date du dernier relevé", type: "date", className: "flex-1 w-3/4"},
    {name: "assurance_proprietaire_date_echeance",
      label: "Date d'échéance", type: "date", className: "flex-1 w-3/4", required: true}
  ],
  
  // Champs pour les assurances locataire
  assurance_locataire: [
    {name: "assurance_locataire", label: "Assurance locataire", type: "toggle", className: "w-1/3"},
    {name: "assurance_locataire_date_dernier_releve",
      label: "Date du dernier relevé", type: "date", className: "flex-1 w-3/4"},
    {name: "assurance_locataire_date_echeance",
      label: "Date d'échéance", type: "date", className: "flex-1 w-3/4", required: true}
  ],
  
  // Champs pour la vérification initiale d'assurance propriétaire
  assurance_proprietaire_verification_initiale: [
    {name: "assurance_proprietaire", label: "Assurance propriétaire", type: "toggle", className: "w-1/3"},
    {name: "assurance_proprietaire_date_dernier_releve",
      label: "Date du dernier relevé", type: "date", className: "flex-1 w-3/4"},
    {name: "assurance_proprietaire_date_echeance",
      label: "Date d'échéance", type: "date", className: "flex-1 w-3/4", required: true}
  ],
  
  // Champs pour la vérification initiale d'assurance locataire
  assurance_locataire_verification_initiale: [
    {name: "assurance_locataire", label: "Assurance locataire", type: "toggle", className: "w-1/3"},
    {name: "assurance_locataire_date_dernier_releve",
      label: "Date du dernier relevé", type: "date", className: "flex-1 w-3/4"},
    {name: "assurance_locataire_date_echeance",
      label: "Date d'échéance", type: "date", className: "flex-1 w-3/4", required: true}
  ],
  
  // Champs pour les diagnostics (utilisés pour la soumission du formulaire)
  diagnostic_dpe: [
    {name: "diagnostic_dpe_note", label: "Note DPE", type: "text"},
    {name: "diagnostic_dpe_date", label: "Date du DPE", type: "date"},
    {name: "diagnostic_dpe_date_echeance", label: "Date d'échéance", type: "date", required: true},
    {name: "diagnostic_dpe_file", label: "Fichier DPE", type: "file"}
  ],
  
  diagnostic_gaz: [
    {name: "diagnostic_gaz_date", label: "Date du diagnostic gaz", type: "date"},
    {name: "diagnostic_gaz_date_echeance", label: "Date d'échéance", type: "date", required: true},
    {name: "diagnostic_gaz_file", label: "Fichier diagnostic gaz", type: "file"}
  ],
  
  diagnostic_electricite: [
    {name: "diagnostic_electricite_date", label: "Date du diagnostic électricité", type: "date"},
    {name: "diagnostic_electricite_date_echeance", label: "Date d'échéance", type: "date", required: true},
    {name: "diagnostic_electricite_file", label: "Fichier diagnostic électricité", type: "file"}
  ],
  
  diagnostic_plomb: [
    {name: "diagnostic_plomb", label: "Plomb détecté", type: "toggle"},
    {name: "diagnostic_plomb_date", label: "Date du diagnostic plomb", type: "date"},
    {name: "diagnostic_plomb_date_echeance", label: "Date d'échéance", type: "date", requiredIfPositive: "diagnostic_plomb"},
    {name: "diagnostic_plomb_file", label: "Fichier diagnostic plomb", type: "file"}
   ],
  
  diagnostic_amiante: [
    {name: "diagnostic_amiante", label: "Amiante détecté", type: "toggle"},
    {name: "diagnostic_amiante_date", label: "Date du diagnostic amiante", type: "date"},
    {name: "diagnostic_amiante_date_echeance", label: "Date d'échéance", type: "date", requiredIfPositive: "diagnostic_amiante"},
    {name: "diagnostic_amiante_file", label: "Fichier diagnostic amiante", type: "file"}
  ]
}

/**
 * Todos los tipos de tareas con sus labels
 * Sincronizado con el enum en app/models/renew_task.rb
 */
export const RENEW_TASK_TYPES = {
  diagnostic_dpe: {
    label: 'DPE',
    value: 'diagnostic_dpe',
    category: 'diagnostic',
    icon: '📊'
  },
  diagnostic_amiante: {
    label: 'Amiante',
    value: 'diagnostic_amiante',
    category: 'diagnostic',
    icon: '🔬'
  },
  diagnostic_electricite: {
    label: 'Électricité',
    value: 'diagnostic_electricite',
    category: 'diagnostic',
    icon: '⚡'
  },
  diagnostic_gaz: {
    label: 'Gaz',
    value: 'diagnostic_gaz',
    category: 'diagnostic',
    icon: '🔥'
  },
  diagnostic_plomb: {
    label: 'Plomb',
    value: 'diagnostic_plomb',
    category: 'diagnostic',
    icon: '🧪'
  },
  assurance_proprietaire: {
    label: 'Assurance propriétaire',
    value: 'assurance_proprietaire',
    category: 'assurance',
    icon: '🏠'
  },
  assurance_locataire: {
    label: 'Assurance locataire',
    value: 'assurance_locataire',
    category: 'assurance',
    icon: '👤'
  },
  assurance_proprietaire_verification_initiale: {
    label: 'Vérification assurance propriétaire',
    value: 'assurance_proprietaire_verification_initiale',
    category: 'assurance',
    icon: '✅'
  },
  assurance_locataire_verification_initiale: {
    label: 'Vérification assurance locataire',
    value: 'assurance_locataire_verification_initiale',
    category: 'assurance',
    icon: '✅'
  },
  assemblee_generale: {
    label: 'Assemblée générale',
    value: 'assemblee_generale',
    category: 'copropriete',
    icon: '👥'
  },
  entretien: {
    label: 'Entretien',
    value: 'entretien',
    category: 'entretien',
    icon: '🔧'
  },
  facturation: {
    label: 'Facturation',
    value: 'facturation',
    category: 'facturation',
    icon: '💰'
  }
}

/**
 * Obtener opciones para select/dropdown
 */
export const renewTaskTypeOptions = Object.values(RENEW_TASK_TYPES).map(type => ({
  label: type.label,
  value: type.value,
  category: type.category
}))

/**
 * Obtener label de un tipo de tarea
 */
export const getRenewTaskTypeLabel = (taskType) => {
  return RENEW_TASK_TYPES[taskType]?.label || taskType
}

/**
 * Obtener categoría de un tipo de tarea
 */
export const getRenewTaskTypeCategory = (taskType) => {
  return RENEW_TASK_TYPES[taskType]?.category || 'unknown'
}

/**
 * Agrupar tipos por categoría
 */
export const groupedRenewTaskTypes = Object.entries(RENEW_TASK_TYPES).reduce((acc, [key, value]) => {
  const category = value.category
  if (!acc[category]) {
    acc[category] = []
  }
  acc[category].push({ ...value, key })
  return acc
}, {})
